import * as React from 'react';
import { RouteComponentProps, withRouter, Route, Redirect } from 'react-router';
import Login from './Login/Login';
import Pricing from './Pricing/Pricing';
import Checkout from './Checkout/Checkout';
import DashBoard from './Dashboard/Dashboard';
import SignUp from './SignUp/SignUp';
import Verify from './Verify/Verify';
import Welcome from './Welcome/Welcome';
import { withUser, WithUser } from './HOC/User';
import KDGlobal from './Global';
import { withTransition } from './HOC/Transition';
import TOC from './TOC/TOC';

interface RootProps extends RouteComponentProps, WithUser {}

class Root extends React.Component<RootProps> {

    private loginRoutes() {
        return (
            <div className="onboard-container">
                <Route path={"/"} component={withTransition(Welcome)} exact />
                <Route path={"/login"} component={withTransition(Login)} exact />
                <Route path={"/sign-up"} component={withTransition(SignUp)} exact />
                <Route path={"/pricing"} component={withTransition(Pricing)} exact />
                <Route path={"/toc"} component={withTransition(TOC)} exact />
            </div>
        )
    }

    private appRoutes() {
        return <div className="app-container">
            <Route path={"/verify"} component={withTransition(Verify)} />
            <Route path={"/checkout"} component={withTransition(Checkout)} />
            <Route path={"/app"} exact render={() => <Redirect to={'/app/dashboard'} />} />
            <Route path={"/app/:subPage"} component={withTransition(DashBoard)} />
            <Route path={"/logout"} render={() => {
                KDGlobal.instance.unsetUser();
                return <Redirect to={'/'} />
            }} exact />
        </div>
    }

    public render() {
        return <div id="container">
            {this.loginRoutes()}
            {this.appRoutes()}
        </div>
    }
}

export default withUser(withRouter(Root))


// WEBPACK FOOTER //
// ./src/components/Root.tsx